import SplitBarComponent from './SplitBar.vue';
export const SplitBar = SplitBarComponent;
export default SplitBar;
